import axios from '../services/sessionApi';
import { pictos } from '../assets/img/pictos';
import { URL } from '../redux/api';
import { toLower, upperFirst } from 'lodash';

export function formatName(firstName, lastName) {
  const formatPrenom = part => {
    if (!part) return '';
    return part
      .split(/([- ])/)
      .map(word => {
        if (word === '-' || word === ' ') return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  };
  const formatNom = part => (part ? part.toUpperCase() : '');
  return `${formatPrenom(firstName)} ${formatNom(lastName)}`.trim();
}

export function formatFonction(fonction) {
  if (!fonction) return '';
  const lowercaseWords = ['de', 'et', 'que', 'du', 'la', 'le', 'en', 'pour', 'aux', 'des'];
  return fonction
    .split(' ')
    .map((word, index) => {
      if (index > 0 && lowercaseWords.includes(word.toLowerCase())) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

/**
 * Company name (exposants): forced uppercase for consistent display.
 */
export function formatCompanyName(str) {
  if (!str || typeof str !== 'string') return '';
  return str.trim().toUpperCase();
}

/**
 * Sector (domaine): first letter of first word uppercase, rest lowercase (e.g. Promotion immobilière).
 */
export function formatSector(str) {
  if (!str || typeof str !== 'string') return '';
  const s = str.trim();
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/**
 * Contact full name (API returns "prenom nom" as contact.nom): split at first space and apply formatName.
 */
export function formatContactNameFromFull(fullName) {
  if (!fullName || typeof fullName !== 'string') return '';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) return formatName(parts[0], '');
  return formatName(parts[0], parts.slice(1).join(' '));
}

/**
 * Display contact name as stored (no forced capitalization). Use on contact, messages, chat pages.
 */
export function displayContactName(firstName, lastName) {
  if (!firstName && !lastName) return '';
  return `${(firstName || '').trim()} ${(lastName || '').trim()}`.trim();
}

/**
 * Display contact full name as stored (no forced capitalization). Use on contact, messages, chat pages.
 */
export function displayContactNameFromFull(fullName) {
  if (!fullName || typeof fullName !== 'string') return '';
  return fullName.trim();
}

export function categories(cat_img, cat_label, expert, speaker) {
  var tabRetour = [];

  if (cat_img !== '') {
    // console.log('vide')
    tabRetour.push({ icone: cat_img, click: false, title: upperFirst(toLower(cat_label)) });
    if (toLower(cat_label) === toLower('Intervenant') || speaker === true) {
      tabRetour.push({ icone: pictos.speaker_icone, click: false, title: 'Speaker' });
    }
  }

  // if (cat === "Exposant") {
  //     tabRetour.push({ icone: pictos.speaker_icone, click: false })
  // }
  // if (cat === "Congressiste") {
  //     tabRetour.push({ icone: pictos.congressiste_icone, click: false })
  // }
  // if (cat === "Intervenant") {
  //     tabRetour.push({ icone: pictos.intervenant_icone, click: false })
  // }
  // if (cat === "Visiteur") {
  //     tabRetour.push({ icone: pictos.visiteur_icone, click: false })
  // }
  // if (cat === "Visiteur premium") {
  //     tabRetour.push({ icone: pictos.visiteur_icone, click: false })
  // }
  // if (cat === "Visiteur classique") {
  //     tabRetour.push({ icone: pictos.visiteur_icone, click: false })
  // }

  if (expert) {
    tabRetour.push({ icone: pictos.expert_icone, click: false, title: 'Expert' });
  }

  return tabRetour;
}

export const deconnexion = (context, navlink) => {
  setTimeout(() => {
    context.setLogged(false);
    localStorage.removeItem('is_logged');
    localStorage.removeItem('tokenAccess');
    localStorage.removeItem('profilUser');
    localStorage.removeItem('persist:root');

    navlink('/');
  }, 1000);
};

export const couleurTheme = categ => {
  if (categ.couleur !== '') {
    if (categ.couleur === 'Rouge') {
      return 'red';
    } else return categ.couleur;
  } else if (categ.couleur === '') {
    return '#e94a14';
  }
};

export function pictosCategorie(cat) {
  if (!cat || cat.label === '' || cat.label === 'Rendez-vous') {
    return pictos.rendez_vous_min_icone;
  }
  if (cat.icone) {
    return cat.icone;
  }
  return pictos.rendez_vous_min_icone;
}

export const recupPassword = (e, email) => {
  e.preventDefault();

  console.log('le mail :', email);

  return axios.post(`${URL}/api/password`, {
    email: email,
  });

  // circlerec(false)
  // message(false)
};

export const contacterBec = (objet, message, token) => {
  return axios.post(
    `${URL}/api/contact`,
    {
      objet: objet,
      message: message,
    },
    {
      headers: {
        Authorization: 'JWT ' + token,
      },
    }
  );
};

export const chatSelected = (
  nom,
  prenom,
  fonction,
  idChat,
  photoContact,
  organisationContact,
  photoOrganisation,
  structure = true
) => {
  return {
    contact: {
      name: `${nom} ${prenom}`,
      fonction: fonction,
      photo: photoContact,
      organisation: organisationContact,
      photo_organisation: structure ? '' : photoOrganisation,
    },
    id: idChat,
  };
};
export const MOIS_BIS = [
  'Janvier',
  'Fevrier',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];
const MOIS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const affichageDate = (date, previousDate) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = MOIS[date.getMonth()];
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  if (
    previousDate &&
    date.getDate() === previousDate.getDate() &&
    date.getMonth() === previousDate.getMonth() &&
    date.getFullYear() === previousDate.getFullYear()
  ) {
    return `${hours}:${minutes}`;
  }

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export function toNormalForm(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export const formatTimeTo24h = value => {
  if (value === null || value === undefined) {
    return '';
  }

  const raw = String(value).trim();
  if (raw === '') {
    return '';
  }

  const meridiemMatch = raw.match(/^(\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?\s*(AM|PM)$/i);
  if (meridiemMatch) {
    let hours = parseInt(meridiemMatch[1], 10);
    const minutes = parseInt(meridiemMatch[2] || '0', 10);
    const period = meridiemMatch[4].toUpperCase();

    if (period === 'PM' && hours < 12) {
      hours += 12;
    }
    if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }

  const parts = raw.split(':');
  if (parts.length >= 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1])) {
    const hours = String(parts[0]).padStart(2, '0');
    const minutes = String(parts[1]).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  return raw;
};
